import React from 'react';
import classnames from 'classnames';

import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';
import {LIST_ROW_CLICK_ACTION_FLAG} from 'client/TeacherDashboard/constants';

/** The design's 960px reading width; no max-width token matches it. */
const CENTERED_CLASS_NAME = 'mx-auto w-full max-w-[960px]';

type Props = React.HTMLAttributes<HTMLDivElement>;

/**
 * Always renders the div, so the content doesn't remount when the flag loads, but keeps it hidden
 * until then: its width isn't known yet.
 */
export const CenteredColumn = ({className, ...rest}: Props) => {
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled(LIST_ROW_CLICK_ACTION_FLAG);

  return (
    <div
      {...rest}
      className={classnames(className, {
        [CENTERED_CLASS_NAME]: isFeatureEnabled,
        invisible: isLoading
      })}
    />
  );
};
